import api from '@/api'

export default {
	/**
	 * 대용량 첨부 템플릿을 가져옵니다.
	 * @param {string} code 대용량 첨부 그룹 코드
	 * @returns template html string
	 */
	getTemplate: function (code: string): Promise<string> {
		return api.get({
			url: '/CubeLook/File/api/BigfileContent',
			params: { code },
		})
	},
}
